import React from "react";

export default function Modal({ show, onClose, title, children, image }) {
  if (show) {
    document.body.classList.add("overflowHidden");
  } else {
    document.body.classList.remove("overflowHidden");
  }
  return (
    <div className={`modal-club${show ? " open" : ""}`}>
      <div className="container">
        <div className="content-modal">
          <div className="title">
            <div className="block md:flex items-center">
              <figure>
                <img src={image} alt="Imagen patrocidador" />
              </figure>
              <h5>{title}</h5>
            </div>
            <button onClick={onClose} className="closeModalBeauty">
              <i className="icon icon-close"></i>
            </button>
          </div>

          {children}
        </div>
      </div>
    </div>
  );
}
